import { nonce, shipyardApiUrl } from '../utils/runtime';

function headers() {
  return {
    'Content-Type': 'application/json',
    ...(nonce ? { 'X-WP-Nonce': nonce } : {}),
  };
}

async function readJson(response) {
  const raw = await response.text();
  const payload = raw ? JSON.parse(raw) : null;
  if (!response.ok) {
    throw new Error(payload?.message || payload?.data?.message || 'Die Werft konnte nicht geladen werden.');
  }
  return payload;
}

export async function loadShipyard() {
  const response = await fetch(shipyardApiUrl || '/wp-json/pfandpirat/v1/shipyard', {
    credentials: 'include',
    headers: nonce ? { 'X-WP-Nonce': nonce } : {},
  });
  return readJson(response);
}

export async function upgradeShipyard() {
  const response = await fetch(`${shipyardApiUrl || '/wp-json/pfandpirat/v1/shipyard'}/upgrade`, {
    method: 'POST',
    credentials: 'include',
    headers: headers(),
    body: JSON.stringify({}),
  });
  return readJson(response);
}
